import React from 'react';
import { Logo } from './Logo';
import { Facebook, Twitter, Linkedin, Mail } from 'lucide-react';
import { Page } from '../App';
interface FooterProps {
  onNavigate: (page: Page) => void;
}
const footerLinks: {
  label: string;
  href: Page;
}[] = [{
  label: 'Home',
  href: 'home'
}, {
  label: 'Service Details',
  href: 'service-details'
}, {
  label: 'About Us',
  href: 'about-us'
}, {
  label: 'Our Service',
  href: 'our-service'
}, {
  label: 'FAQs',
  href: 'faq'
}, {
  label: 'Contact Us',
  href: 'contact-us'
}, {
  label: 'Cancellation Policy',
  href: 'cancellation-policy'
}, {
  label: 'Refund Policy',
  href: 'refund-policy'
}, {
  label: 'Privacy & Cookie Policy',
  href: 'privacy-policy'
}, {
  label: 'Terms & Conditions',
  href: 'terms-conditions'
}];
export function Footer({
  onNavigate
}: FooterProps) {
  const handleNavClick = (page: Page) => {
    onNavigate(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-slate-dark text-white pt-16 pb-8" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-16">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-17">
            <Logo variant="light" data-id="element-18" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-19">
              Unlimited Reading Made Simple. Access thousands of curated ebooks
              instantly with our subscription service.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-20">
            <h3 className="font-semibold text-lg mb-6 text-accent" data-id="element-21">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-22">
              {footerLinks.map(link => <li key={link.label} data-id="element-23">
                  <button onClick={() => handleNavClick(link.href)} className="text-slate-300 hover:text-accent transition-colors text-sm text-left" data-id="element-24">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div data-id="element-25">
            <h3 className="font-semibold text-lg mb-6 text-accent" data-id="element-26">
              Contact Us
            </h3>
            <div className="flex items-start gap-3 text-slate-300 text-sm" data-id="element-27">
              <Mail className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-28" />
              <a href="mailto:manishhoran123@gmail.com" className="hover:text-white transition-colors" data-id="element-29">
                manishhoran123@gmail.com
              </a>
            </div>
          </div>

          {/* Column 4: Hours & Social */}
          <div data-id="element-30">
            <h3 className="font-semibold text-lg mb-6 text-accent" data-id="element-31">
              Opening Hours
            </h3>
            <p className="text-slate-300 text-sm mb-6" data-id="element-32">
              Mon - Fri: 9:00 AM - 5:00 PM
              <br data-id="element-33" />
              Sat - Sun: Closed
            </p>

            <h4 className="font-semibold text-sm mb-4 text-white" data-id="element-34">Follow Us</h4>
            <div className="flex gap-4" data-id="element-35">
              <a href="#" className="bg-slate-700 p-2 rounded-full hover:bg-accent transition-colors" data-id="element-36">
                <Facebook className="w-5 h-5 text-white" data-id="element-37" />
              </a>
              <a href="#" className="bg-slate-700 p-2 rounded-full hover:bg-accent transition-colors" data-id="element-38">
                <Twitter className="w-5 h-5 text-white" data-id="element-39" />
              </a>
              <a href="#" className="bg-slate-700 p-2 rounded-full hover:bg-accent transition-colors" data-id="element-40">
                <Linkedin className="w-5 h-5 text-white" data-id="element-41" />
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges Row */}
        <div className="border-t border-slate-700 pt-8 pb-8" data-id="element-42">
          <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-slate-400 text-sm font-medium" data-id="element-43">
            <span className="flex items-center gap-2" data-id="element-44">
              <span className="w-2 h-2 bg-accent rounded-full" data-id="element-45"></span>
              UK-based
            </span>
            <span className="flex items-center gap-2" data-id="element-46">
              <span className="w-2 h-2 bg-accent rounded-full" data-id="element-47"></span>
              Secure Payments
            </span>
            <span className="flex items-center gap-2" data-id="element-48">
              <span className="w-2 h-2 bg-accent rounded-full" data-id="element-49"></span>
              Clear Pricing
            </span>
            <span className="flex items-center gap-2" data-id="element-50">
              <span className="w-2 h-2 bg-accent rounded-full" data-id="element-51"></span>
              Reliable Access
            </span>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-700 pt-8 text-center" data-id="element-52">
          <p className="text-slate-500 text-sm" data-id="element-53">
            &copy; {new Date().getFullYear()} Bluecore. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}